export default __webpack_public_path__ + "14f21dd7b6620d0a916a42c16333f855.png";